<template>
  <div class="w-screen sm:h-screen flex flex-col overflow-hidden">
    <router-view/>
    <IwalyNotifications/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import IwalyNotifications from '@/components/global/IwalyNotifications.vue';

export default {
  components: {
    IwalyNotifications,
  },
  methods: {
    ...mapActions({
      FETCH_SERVICE_CATEGORIES: 'ACT_FETCH_SERVICE_CATEGORIES',
      FETCH_COUNTRIES: 'ACT_FETCH_COUNTRIES',
    }),
  },
  mounted() {
    this.FETCH_SERVICE_CATEGORIES();
    this.FETCH_COUNTRIES();
  },
};
</script>
